module.exports = __webpack_public_path__ + "static/media/1023708.065d2972.png";